<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="w-full max-w-[512px] bg-[#0D0D0D] p-6">
    <div class="flex flex-col items-center gap-3 text-center">
      <h2 class="text-2xl font-bold text-white">
        Available after subscription
      </h2>
      <p class="m-0 max-w-[360px] text-sm/5 text-[#BEBEBE]">
        This feature includes functionality available only to users with a paid
        subscription plan. Please subscribe to a paid plan.
      </p>
    </div>

    <div
      class="mt-8 flex flex-col-reverse gap-4 md:flex-row md:justify-between"
    >
      <NordyButton
        button-style="secondary"
        class-name="h-12 w-full px-5 text-base font-bold md:w-[130px]"
        data-testid="close-button"
        @click="close"
      >
        Close
      </NordyButton>
      <NordyButton
        button-style="primary"
        class-name="h-12 w-full px-5 text-base font-bold md:w-[210px]"
        data-testid="subscribe-button"
        @click="openPricing"
      >
        Go to subscription
      </NordyButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import NordyButton from '@/nordy/components/NordyButton.vue'
import { useDialogStore } from '@/stores/dialogStore'

const DIALOG_KEY = 'nordy-install-request-subscription'

function close() {
  useDialogStore().closeDialog({ key: DIALOG_KEY })
}

function openPricing() {
  window.open('/pricing', '_blank')
  close()
}
</script>
